import { store, getContext, navigate } from '@wordpress/interactivity';

const { state, actions } = store( 'bv-space', {
	actions: {
		updateCount() {
			jQuery(function ($) {
				const resultsCount = $('div[data-results-count]').attr('data-results-count');
				const type = ($('[data-results-count] li').first().attr('class') || '').match(/type-([a-z0-9_-]+)/)?.[1] || null;
				const first_call = new URL(window.location.href).searchParams.get('first_call');
				if (type && first_call) {
					const url = new URL(window.location.href);
					url.searchParams.delete('first_call');
					if (state.searchValue) {
						state.activeButton = type;
						const url = new URL(window.location.href);
						url.searchParams.delete('first_call');
						url.searchParams.set('fagunivers_type', type);
						url.searchParams.set('iapi', 1);
						window.history.replaceState({}, '', url.toString());
						actions.updateURL();
					}
				}

				var custom_results_text = resultsCount == 1 ? 'resultat' : 'resultater';
				if (state.activeMalgruppe) {
					var malgruppe_name = 'målrettet ' + '<strong>' + state.headerMalgruppe.name + '</strong>';
					custom_results_text = resultsCount == 1 ? 'resultat for ' + malgruppe_name : 'resultater for ' + malgruppe_name;
				}
				$('#bv-total-results').html('<strong>' + resultsCount + '</strong> ' + custom_results_text);
				jQuery(function ($) {
					//get data-header-type
					const headerType = $('.wp-block-acf-maalgruppe-header').data('header-type');
					$('.wp-block-acf-maalgruppe-header').hide();
					if (headerType == 'post_type') {
						if ($('#maalgruppe-header-' + state.activeButton).length === 0) {
							$('#maalgruppe-header-post').show();
						} else {
							$('#maalgruppe-header-' + state.activeButton).show();
						}
					} else {
						if ($('#maalgruppe-header-' + state.activeMalgruppe).length === 0) {
							$('#maalgruppe-header-alle').show();
						} else {
							$('#maalgruppe-header-' + state.activeMalgruppe).show();
						}
					}
					$(document).trigger('updatedDynamicHeaders');
				});
			});
		}
	}
});
